export default "__VITE_ASSET__DVp7uWbg__"